import Vault from "./Vault";
const vault = Vault.getInstance();

function _getHeaders() {
    return {
        'Authorization': `Bearer ${vault.getItem('session')}`,
    };
}

function _processResponse(response) {
    if (response.ok) {
        return response.json();
    }

    throw new Error(`Invalid response received (${response.status})`);
}

function getAllRecipes(search) {
    const s = search ?? '';
    const query = new URLSearchParams({s});
    return fetch(`/api/recipes/all?${query.toString()}`, {
        headers: _getHeaders(),
    }).then(_processResponse);
}

function getRecipe(recipeId) {
    return fetch(`/api/recipes/${recipeId}`, {
        headers: _getHeaders(),
    }).then(_processResponse);
}

function check() {
    const authLocal = localStorage.getItem('session');
    const headers = _getHeaders();
    if (authLocal) {
        vault.setItem('session', authLocal);
    }
    return fetch('/api/alive', {
        headers: authLocal ? { 'Authorization': `Bearer ${authLocal}` } : headers,
        method: 'POST',
    })
        .then(response => {
            if (response.status !== 200) {
                return false;
            }
            return true;
        });
}

export {
    getAllRecipes,
    getRecipe,
    check,
};
